// GLOBAL APP CONTROLLER
const controller = {
    init() {
        if (jQuery(window).width() > 767) {
            var element = jQuery('.content-sticky');
            var container = jQuery('.block-side-content-scrolling-cards');
            var top = jQuery('.main-header').outerHeight() + 50;
            var elementTop = element.offset().top - jQuery('.main-header').outerHeight() - 40;
            var elementHeight = container.outerHeight();
            var elementBottom = element.offset().top + elementHeight;
            jQuery(window).scroll(function(){
                if ( jQuery(window).scrollTop() >= elementTop && jQuery(window).scrollTop() < elementBottom) {
                    element.addClass("visible").css("position", "sticky").css("top", top).css("position", "-webkit-sticky");
                } else {
                    element.removeClass("visible").css("position", "static");
                }
            });
        }
    },
    loaded() {},
    resized() {},
    scrolled() {},
    keyDown() {},
    mouseUp() {},
};
export default controller;